/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class ServerPrivateAPI {

    static csrfParameterName = null;
    static csrfToken = null;

    /**
     *
     * @return Promise
     */
    static fetchData() {
        return ServerPrivateAPI.#getJson('/app/finance/private/data');
    }

    /**
     *
     * @return Promise
     */
    static postData(dataToSend) {
        return ServerPrivateAPI.#postJson('/app/finance/private/data', dataToSend);
    }

    /**
     *
     * @return Promise
     */
    static fetchSettings() {
        return ServerPrivateAPI.#getJson('/app/finance/private/settings');
    }

    /**
     *
     * @return Promise
     */
    static postSettings(dataToSend) {
        return ServerPrivateAPI.#postJson('/app/finance/private/settings', dataToSend);
    }

    /**
     *
     * @return Promise
     */
    static updateServerData(incremental = false) {
        return ServerPrivateAPI.#postJson('/app/finance/private/update?incremental=' + incremental, {});
    }

    /**
     * @param currencies {string[]}
     * @return Promise
     */
    static fetchFxRates(currencies) {
        let query = encodeURIComponent(currencies.join(','));
        return ServerPrivateAPI.#getJson('/app/finance/private/fx?currencies=' + query);
    }

    static #getJson(url) {
        return fetch(url).then(response => ServerPrivateAPI.#parseJsonResponse(response));
    }

    static #postJson(url, dataToSend) {
        if (ServerPrivateAPI.csrfParameterName !== null) {
            dataToSend[ServerPrivateAPI.csrfParameterName] = ServerPrivateAPI.csrfToken;
        }

        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        }).then(response => ServerPrivateAPI.#parseJsonResponse(response));
    }

    static #parseJsonResponse(response) {
        if (!response.ok) {
            throw response;
        }
        return response.json();
    }
}
